module.exports = __webpack_public_path__ + "static/img/Reading_room2.0d8da01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Reading_room2.png
// module id = /dhW
// module chunks = 0